<app-settlement *ngIf="english"></app-settlement>
<app-settlement-hindi *ngIf="hindi"></app-settlement-hindi>